// extracted by mini-css-extract-plugin
export default {"searchBox":"KeywordInput_searchBox__1VQ5Q","resetButton":"KeywordInput_resetButton__0GmHl","searchIcon":"KeywordInput_searchIcon__3oOnD"};